import { EntityStatus } from '../../../../src';

export interface IDevice {
  serialNumber: string;
  version?: number;
  deviceUid?: string;
  status?: EntityStatus;
  description?: string;
  createdDate?: string;
  modifiedDate?: string;
  printerFormat?: string;
}
